import http from '@/support/services/HttpService';

class OverdueBilletParametersRequest {
  static baseUrl() {
    return 'v1/parametrosPagamentoBoletoInadimplente';
  }

  static save(payload) {
    return http.put(this.baseUrl(), payload);
  }

  static get() {
    return http.get(this.baseUrl());
  }
}

export default OverdueBilletParametersRequest;
